
export function getBuilderServiceClass(rootState, currentService, serviceFallback) {
    return rootState.builders.version === 'v3' ? currentService : serviceFallback;
}